import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Banner from '@src/pc/components/Banner';
import Nav from '@src/pc/components/Nav';
import Footer from '@src/pc/components/Footer';
import ModuleHead from '@src/pc/components/ModuleHead';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';
import Chip from 'Chip';
import Atlas from './Atlas';
import YearNav from './YearNav';
import ChipView from './ChipView';

const Layout = ({ content }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [isShowAtlas, setIsShowAtlas] = useState(true);
    const { year2022, year2021, year2020, year2019, year2018, year2017, year2016 } = content;
    const yearList = [year2022, year2021, year2020, year2019, year2018, year2017, year2016];

    const changeNavHandle = index => {
        setIsShowAtlas(false);
        setTimeout(() => {
            setActiveIndex(index);
            setIsShowAtlas(true);
        }, 100);
    };

    return (
        <div className={styles.layout}>
            <Banner content={content.banner} />
            <Nav content={content.nav} activeIndex={4} />
            <div className={styles.space21} />
            <div className={styles.col_1000}>
                <Chip id="260455" type="struct" title="模块头" groupName="模块头" content={content.atlasHead}>
                    <ModuleHead isShowMore={false} />
                </Chip>
                <Chip id="260465" type="struct" title="年份列表" groupName="年份" content={content.yearList}>
                    <YearNav activeIndex={activeIndex} changeNavHandle={changeNavHandle} />
                </Chip>
                <div className={styles.atlasBox}>{isShowAtlas ? <Atlas content={yearList[activeIndex]} /> : null}</div>
            </div>
            <div className={styles.space50} />
            <Footer content={content.footer} />
            <ChipView />
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
